import React from 'react';
import { UsersRoundIcon } from 'lucide-react';
import { LAUNCH_LIMIT } from '../data/programa';
export function LaunchOfferBadge({
  className = ''
}: {
  className?: string;
}) {
  return <span className={`inline-flex items-center gap-2 rounded-full border border-gold/60 bg-line px-4 py-1.5 text-[12px] font-medium uppercase tracking-[0.1em] text-gold shadow-[0_0_16px_rgba(255,159,28,0.28)] ${className}`} data-id="element-18" data-mp="13wakpeubs2z6">
      <UsersRoundIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-19" data-mp="1wlzmhuev071u" />
      Precio de lanzamiento
    </span>;
}
export function LaunchOfferBlock() {
  return <div className="mx-auto max-w-xl rounded-2xl border border-gold bg-white/[0.04] px-7 py-6 text-center backdrop-blur-[10px]" data-id="element-20" data-mp="1mv4xiia8atcp">
      <LaunchOfferBadge data-id="element-21" data-mp="1rsy4ven9ptek" />
      <p className="mt-4 text-[17px] font-semibold leading-snug text-ice" data-id="element-22" data-mp="1rs56b0ygqa7i">
        Válido hasta agotar las {LAUNCH_LIMIT} al precio de lanzamiento
      </p>
      <p className="mt-2 text-[14px] leading-[1.6] text-cool" data-id="element-23" data-mp="2kaiue8tzyhte">
        Después sube de precio y no vuelve al valor actual.
      </p>
    </div>;
}